import * as S from '@effect/schema/Schema';
export var NotFoundBlockConfig = S.struct({
  typename: S.literal('NotFoundBlock'),
  id: S.string,
  hash: S.string
});